module.exports = __webpack_public_path__ + "img/mail-sent.9b6b0b85.svg";